import { render, staticRenderFns } from "./TkGlobalLoadingProgressbar.vue?vue&type=template&id=b97dc8aa&"
import script from "./TkGlobalLoadingProgressbar.vue?vue&type=script&lang=js&"
export * from "./TkGlobalLoadingProgressbar.vue?vue&type=script&lang=js&"
import style0 from "./TkGlobalLoadingProgressbar.vue?vue&type=style&index=0&id=b97dc8aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports